import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

import ApplicationController from './application_controller';

/**
 * Property-photo gallery (PhotoSwipe v5) + a "See all / See less" toggle.
 *
 * The lightbox is scoped to the desktop grid (`gallery` target). v5 builds its own
 * accessible dialog (focus-in/trap/Escape/focus-return + ARIA controls) and binds
 * the thumbnail clicks itself. Slide data comes from the `.gallery-item` anchors
 * (full image in `href`, dimensions in `data-size="WxH"`).
 */
export default class extends ApplicationController {
  static targets = ['gallery', 'toggleButton'];

  connect() {
    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.galleryTarget,
      children: '.gallery-item',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 1,
      loop: true,
    });

    this.lightbox.addFilter('domItemData', (itemData, element) => {
      const [w, h] = (element.getAttribute('data-size') || '800x600').split('x').map(Number);
      const img = element.querySelector('img');
      itemData.src = element.getAttribute('href');
      itemData.width = w || 800;
      itemData.height = h || 600;
      itemData.msrc = img ? img.getAttribute('src') : undefined;
      itemData.alt = img ? img.getAttribute('alt') || '' : '';
      return itemData;
    });

    this.lightbox.init();
  }

  disconnect() {
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }

  toggle(event) {
    event.preventDefault();
    const isExpanded = this.toggleButtonTarget.textContent.trim() === 'See less';

    if (isExpanded) {
      this.hideAllImages();
      this.toggleButtonTarget.textContent = 'See all';
    } else {
      this.showAllImages();
      this.toggleButtonTarget.textContent = 'See less';
    }
  }

  showAllImages() {
    this.galleryTarget.querySelectorAll('.gallery-item.hidden').forEach((item) => {
      item.classList.remove('hidden');
    });
  }

  hideAllImages() {
    this.galleryTarget.querySelectorAll('.gallery-item').forEach((item, index) => {
      if (index >= 8) {
        item.classList.add('hidden');
      }
    });
  }
}
